import { render, staticRenderFns } from "./WorkLocationsPage.vue?vue&type=template&id=e81314ee&"
import script from "./WorkLocationsPage.vue?vue&type=script&lang=js&"
export * from "./WorkLocationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports